import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackSandboxEvent = createTrackerForCategory('Sandbox');

export interface TrackSandboxCalloutClickedProps {
  source: 'get-started' | 'onboarding' | 'launch-insights' | 'observability' | 'sdk-setup';
}

export const trackSandboxCalloutClicked = (props: TrackSandboxCalloutClickedProps) => {
  trackSandboxEvent('Sandbox Callout Clicked', props);
};

export const trackSandboxVisible = () => trackSandboxEvent('Sandbox Visible');
export const trackSandboxHidden = () => trackSandboxEvent('Sandbox Hidden');
export const trackSandboxModalEmailSubmitted = (email: string) =>
  trackSandboxEvent('Sandbox modal email submitted', { email });

export const trackSandboxBannerReadDocs = () => trackSandboxEvent('Sandbox banner docs link clicked');

export const trackSandboxBannerGetDemo = () => trackSandboxEvent('Sandbox banner get demo link clicked');

export const trackSandboxBannerStartFreeTrial = () => trackSandboxEvent('Sandbox banner start free trial link clicked');
